import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit }, id) {
      return ajax
        .get("Promotion/api/Categories?contractId=" + id + "&Take=100&Skip=0")
        .then(r => {
          commit("setList", r.data.data);
        });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Promotion/api/Categories", model);
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete(
        "Promotion/api/Categories",
        { data: { id: id } },
        { headers: { "Content-Type": "application/json" } }
      );
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Promotion/api/Categories", model);
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
